module.exports = __webpack_public_path__ + "images/mdj/members/resume/common/common_bg01_this-60a449655fa598a3eec43bef19d4fa61.jpg";